'use client';

import Image from 'next/image';

/**
 * Renders blog images optimized via Next.js Image.
 * Supports both Cloudinary URLs and standard image URLs.
 */
export default function CloudinaryBlogImage({
  src,
  alt = 'Blog Image',
  width = 800,
  height = 500,
  fill = false,
  sizes,
  className = '',
  priority = false,
  crop,
  ...props
}) {
  if (!src) return null;

  return (
    <Image
      src={src}
      alt={alt}
      width={fill ? undefined : width}
      height={fill ? undefined : height}
      fill={fill}
      sizes={sizes}
      priority={priority}
      className={className}
      {...props}
    />
  );
}
